// This file is auto-generated.
// It's responsible for giving the view it's own Flow context.

import { Flow } from 'Simple/Flow'
import React from 'react'
import AppointmentHistory from './data'

export default function AppointmentHistoryFlow({ children, ...props }) {
  return (
    <Flow viewPath={props.viewPath} flowDefinitionViewPathSource="/DesignSystem/AppointmentHistory">
      <AppointmentHistory {...props}>
        {children}
      </AppointmentHistory>
    </Flow>
  )
}
